import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls

export const fetchDistributorList = createAsyncThunk("fetchDistributorList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.becomeDistributorList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&from_date=${data?.fromDate}&${data?.toDate ? `to_date=${data?.toDate}` : ""}&search=${data.search || ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.becomeDistributorList} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});


export const fetchNewsletterList = createAsyncThunk("fetchNewsletterList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.newsletter}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&from_date=${data?.fromDate}&${data?.toDate ? `to_date=${data?.toDate}` : ""}&search=${data.search || ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.newsletter} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchContactList = createAsyncThunk("fetchContactList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.contactList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&from_date=${data?.fromDate}&${data?.toDate ? `to_date=${data?.toDate}` : ""}&search=${data.search || ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.contactList} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchInquiryRequests = createAsyncThunk("fetchInquiryRequests", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.inquiryRequest}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&from_date=${data?.fromDate}&${data?.toDate ? `to_date=${data?.toDate}` : ""}&search=${data.search || ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.inquiryRequest} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualQuoteReq = createAsyncThunk("fetchIndividualQuoteReq", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualQuoteRequest}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.individualQuoteRequest} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});